module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("4.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('h3', {
    staticClass: "chaptitle"
  }, [_vm._v("WELCOMING ALL PARTS OF OURSELVES, OUR INNER AND OUTER SELVES, OUR BODIES, ALL OF IT!")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“I surrendered myself to the cages of others’ expectations, cultural mandates, and institutional allegiances.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("—Glennon Doyle, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Untamed:")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stop Pleasing, Start Living")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "alt": "images",
      "src": "images/fig7.jpg"
    }
  })])]), _c('h3', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("All Parts Are Welcome, Welcoming Our Multiplicity")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('h3', {
    staticClass: "title1"
  }, [_vm._v("[Inner and Outer]")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some psychologists refer to the self as having three major components: the outward persona, which is the one you project to the world and others; the experiential self, which is closely tied to memory and how you move through time; and the private selfconscious system, which is your self-concept, beliefs, morals, and values that creates the internal description of who you are. Here, we are talking about the inner you and not concentrating on your body yet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I remember struggling with this in my teens, feeling like the person I presented to the world was not the person I felt I was inside. I remember feeling that specific memories were so unpleasant that I wanted to wipe them from my being. They felt like tarnished parts of my mind that were rusting and corroding good memories. I was at odds with myself. I think many people feel like this, especially if there is part of their self-conscious system that they feel would not be received well by the outside world. In essence, you feel like you are pretending to feel like someone else. This can become the soil that will grow the seeds of shame and self-hatred.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("It is essential to realize that all parts of you are welcome here. All parts. It is crucial to understand that we all have these components of self. We all have an internal landscape and an external garden. We manicure the external maybe a little bit more than the raw and rolling wildlands of our internal self. We all do this. You are not alone. It is essential to recognize this and to realize that sometimes, especially if we are not feeling safe, we may not share some of who we are. This is not inauthentic; it ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("can feel like survival when you feel as though the spaces you live in are not as safe as you need them to be. It’s okay; we have all been there.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Then there is your body, the vehicle we use to get around. While we all have relationships with our bodies, these relationships are complicated. As we move through life, our relationships with our bodies change. We develop negative perspectives of our bodies for many reasons. Again, things like sociopolitical factors, context, identities of privilege and power, family beliefs, societal conditioning, media, and so many more factors play a role in the relationship we have with our bodies. Finding a place of contentment is challenging at times. We celebrate individuality, yet also want to look like the stereotypical, societal version of “good-looking.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As Glennon Doyle alludes to in the quote above, we are all in cages of some kind. It must be part of the human experience. The hope is that we do not have to live in the cages. If we look closely, the door to the cage isn’t locked. We can simply walk out if we want to. Freedom is possible. Hopefully, this book will help you step out of the cages in which you feel imprisoned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("If you are supporting someone, it is important to remember all the facets of a person. We are not simple creatures. Some cultures believe that we are not just this person living on this planet, but we come with the history of our ancestors, with the karma of past lives. We are complicated in the most wonderful way. You will never experience something so wild as being in a human body walking through a lifetime. It is the only ride that leads you to beauty, both bitter and sweet.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Your parts are complicated. It is hard to reconcile all of it. Most of the time, we may even love ourselves, hate ourselves, think ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("we are ugly and beautiful, good and bad, helpful and helpless, happy and sad, all in one day. Change is constant. It is okay to move through these things as they come and experience them, be curious, and let them pass like a cloud in a summer sky. If you deny yourself the ability to move through all that life presents, you will become stuck. Some will say you have not processed your experience and are not allowing yourself to get beyond it. If you stuff it down, it will bubble up. The only way to let it go is to work through it. The poet Rumi refers to our inner self as a guesthouse for all the emotions that come to our door, and says we should welcome them all to our table. Allow them to do what they will do, and then bid them goodbye. Welcome what comes, even if they are guests you don’t want. There is no other way to be your true self than to address all the parts of you with love and kindness toward yourself.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5101c7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter04.vue
// module id = 90
// module chunks = 0